var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCrossIconBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#191918",
  d: "m8.95 8.008 3.53-3.529a.666.666 0 1 0-.943-.942L8.008 7.065 4.48 3.537a.667.667 0 0 0-.943.942l3.529 3.529-3.53 3.529a.667.667 0 1 0 .944.942l3.528-3.528 3.529 3.528a.667.667 0 0 0 .942-.942z"
})));
export { SvgCrossIconBlack as ReactComponent };
export default __webpack_public_path__ + "091ef9fc90191bb21af2c55124e48224.svg";